import { Heading } from "@sentricmusic/ui";
import { useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { useGetMyAccount, useGetSetlists } from "@/api/queries";
import useSiteConfigAuth from "@/api/sanity/queries/getSiteConfigWithCode";
import useAppStore from "@/store/appStateZustand";

import AllSetlistsTable from "./components/AllSetlistsTable";

function Setlists() {
  const selectedAccountValue = useAppStore(s => s.selectedAccount);
  const selectedAccount = typeof selectedAccountValue === "string" ? selectedAccountValue : "";

  const navigate = useNavigate();
  const { data: siteConfig } = useSiteConfigAuth();
  const noGigs = siteConfig?.disable_gigs;
  useEffect(() => {
    if (noGigs) {
      void navigate({ to: "/" });
    }
  }, [noGigs, navigate]);
  const myAccount = useGetMyAccount({
    artistaccountcode: selectedAccount,
  });

  const setlists = useGetSetlists({
    ac: selectedAccount,
    oc: myAccount?.data?.originatorcode?.code,
  });
  const { refetch } = setlists;

  useEffect(() => {
    if (selectedAccount) {
      void refetch();
    }
  }, [selectedAccount, refetch]);

  const { t } = useTranslation();

  return (
    <>
      <div className="flex-1 order-last xl:w-full min-h-50 lg:min-h-screen-minus-header">
        <Heading as="h3" className="mb-8">{t("gigs:your-setlists-header")}</Heading>
        <div className="bg-white rounded-lg p-4 md:px-10 md:py-10 overflow-x-auto">
          <AllSetlistsTable setlists={setlists} />
        </div>
      </div>
    </>
  );
}
export default Setlists;
